import { Section } from '../../models/menu.interfaces';

export const ReceiptsSectionMocks: Section = {
  id: 'receipts',
  title: 'Receipts',
  items: [],
  url: '/mydelta/walletMyReceiptSummary',
  opened: false
};
